import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";
import { connect } from 'react-redux';

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import routes from "routes.js";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.jsx";

import image from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo-white.svg";
import { appConfigsRequest } from "../actions/appConfigs";
import { logout } from "../actions/loginPage";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false,
      image: image,
      color: "blue",
      bgColor: "black",
      hasImage: true,
      fixedClasses: "dropdown"
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  componentWillMount() {

    if(this.checkSignedIn()){
      this.props.dispatch(appConfigsRequest());

    }
   
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  checkSignedIn() {
    const { AuthData } = this.props.loginData;
    if(AuthData) {
      const currentTimestamp = new Date().getTime();
      if(currentTimestamp <= AuthData.expiresIn) {
        const remainingTime = (AuthData.expiresIn - currentTimestamp)
        setTimeout(() => this.props.history.replace('/auth/lock-screen-page', null), remainingTime);
        return true
      } else {
        this.props.history.replace('/auth/lock-screen-page', null);
      }
    }
    this.props.history.replace('/', null);
    return false
  }

  handleImageClick = image => {
    this.setState({ image: image });
  };
  handleColorClick = color => {
    this.setState({ color: color });
  };
  handleBgColorClick = bgColor => {
    this.setState({ bgColor: bgColor });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/admin/full-screen-maps";
  }

  getRoutes = routes => {
    const { AuthData } = this.props.loginData;
    const user = AuthData ? AuthData.user : {};

    if(!user.external){
      return routes.map((prop, key) => {
        if (prop.collapse) {
          return this.getRoutes(prop.views);
        }
        if (prop.layout === "/admin") {
          return (
            <Route
              path={prop.layout + prop.path}
              component={prop.component}
              key={key}
            />
          );
        } else {
          return null;
        }
      });
    }else{
      return routes.map((prop, key) => {
        if (prop.collapse) {
          return this.getRoutes(prop.views);
        }
        if (prop.layout === "/admin") {
          if(prop.showToExternal === user.external && (!prop.disallowedRoles.includes(user.role))){
            return (
              <Route
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          }else {
            return null;
          }
         
        } else {
          return null;
        }
      });
    }

  };

  getSideBarRoutes = routes => {
    const { AuthData } = this.props.loginData;
    const user = AuthData ? AuthData.user : {};
    let processedRoutes = []

    if(!user.external){
      routes.forEach(prop => {
        if(prop.layout === "/admin" && !prop.innerPage) {
          if(prop.hideToInternal === user.external && !prop.disallowedRoles.includes(user.role)){
            processedRoutes.push(prop);
          }
        } else if(prop.collapse === true ) {
          
          if(prop.hideToInternal === user.external && !prop.disallowedRoles.includes(user.role)){
            processedRoutes.push(prop);
          }
        }
      });
    }else{
      routes.forEach(prop => {
        if(prop.layout === "/admin" && !prop.innerPage) {
           if(prop.showToExternal === user.external && (!prop.disallowedRoles.includes(user.role))){
            processedRoutes.push(prop);
          }
        } else if(prop.collapse === true) {
          prop.views.forEach(prop => {
            if(prop.layout === "/admin" && !prop.innerPage) {
               if(prop.showToExternal === user.external && (!prop.disallowedRoles.includes(user.role))){
                processedRoutes.push(prop);
              }
            } 
          });
        }
      });
    }

   
   return processedRoutes;
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  logout() {
    this.props.dispatch(logout());
    this.props.history.replace('/', null);

  }
  render() {
    const { classes, ...rest } = this.props;

    const { AuthData } = this.props.loginData;
    const user = AuthData ? AuthData.user : {};

    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={this.getSideBarRoutes(routes)}
          logo={logo}
          image={this.state.image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color={this.state.color}
          bgColor={this.state.bgColor}
          miniActive={this.state.miniActive}
          fullname={`${user.firstName} ${user.lastName}`}
          {...rest}
          logout={this.logout.bind(this)}
        />
        <div className={mainPanel} ref="mainPanel">
          <AdminNavbar
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            handleDrawerToggle={this.handleDrawerToggle}
            logout={this.logout.bind(this)}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>
                <Switch>{this.getRoutes(routes)}</Switch>
              </div>
            </div>
          ) : (
            <div className={classes.map}>
              <Switch>{this.getRoutes(routes)}</Switch>
            </div>
          )}
          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(
  connect(state => ({ 
    configsData: state.appConfigState,
    loginData: state.loginState,
  }))(Dashboard)
  );
